/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ eventIndex: NonNullable<unknown> }} Event_Text_Editor_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Text editor for event {eventIndex}" |
*
* @param {Event_Text_Editor_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_text_editor_aria_label = /** @type {((inputs: Event_Text_Editor_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Text_Editor_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Editeur de texte pour l'evenement ${i?.eventIndex}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Texteditor für Ereignis ${i?.eventIndex}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Editor di testo per l'evento ${i?.eventIndex}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Текстовый редактор для мероприятия ${i?.eventIndex}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Editor de texto para el evento ${i?.eventIndex}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`事件 ${i?.eventIndex} 的文本编辑器`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`イベント ${i?.eventIndex} のテキストエディター`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`इवेंट ${i?.eventIndex} के लिए टेक्स्ट एडिटर`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Editor de texto para o evento ${i?.eventIndex}`)
	return /** @type {LocalizedString} */ (`Text editor for event ${i?.eventIndex}`)
});